module.exports = __webpack_public_path__ + "img/Physique-1536x864.49bb83ca.jpg";